<template>
  <section class="main-panel__grid">

    <SideBarComponent class="main-panel__sidebar"></SideBarComponent>

    <section class="main-panel__content">
      <header class="header-main">
        <NavBar></NavBar>
      </header>
      <slot></slot>
    </section>
  </section>
</template>
<script>
import NavBar from './NavBar.vue';
import SideBarComponent from './SideBarComponent.vue';

export default {
  name: 'App',
  components: { SideBarComponent, NavBar },
  computed: {},

};
</script>
